function game_1005()
{

}
game_1005.read_odd = function(id)
{
  if(id === 1)
  {
    return "2";
  }
  else if(id === 2)
  {
    return "3";
  }
  else if(id === 3)  {
    return "4";
  }
  else if(id === 4)  {
    return "5";
  }
  else if(id === 5){
    return "6";
  }
  else if(id === 6){
    return "7";
  }
  else if(id === 7){
    return "8";
  }
  else if(id === 8){
    return "9";
  }
  else if(id === 9){
    return "10";
  }
  else if(id === 10){
    return "11";
  }
  else if(id === 11){
    return "12";
  }
  else if(id === 12){
    return "15";
  }
  else if(id === 13){
    return "20";
  }
  else if(id === 14){
    return "13";
  }
  else if(id === 15){
    return "25";
  }

  else if(id === 16){
    return "30";
  }
  else if(id === 17){
    return "40";
  }
  else if(id === 18){
    return "50";
  }
  else if(id === 19){
    return "60";
  }
  else if(id === 20){
    return "70";
  }
  else if(id === 21){
    return "100";
  }
  else if(id === 22){
    return "80";
  }
  else if(id === 23){
    return "130";
  }
  else if(id === 24){
    return "150";
  }
  else if(id === 100){
    return  "200";
  }
  else if(id === 200){
      return  "50-1000";
  }
  else if(id === 201){
    return  "10";
  }
  else if(id === 202){
    return  "10";
  }
  else if(id === 203){
    return  "10";
  }
  else if(id === 204){
    return  "100";
  }
  else if(id === 205){
    return  "50-200";
  }
  else if(id === 206){
    return  "60-900";
  }
  else if(id === 207){
    return  "150-600";
  }
  return  "";
}

export {
  game_1005
};



// WEBPACK FOOTER //
// ./src/components/fish/game_1005.js